import {
  TCreateCompanySpecificBusinessClassificationReqDto,
  TCreateCompanySpecificBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/create-company-business-classification.dto";
import {
  TCreateCompanySpecificIndustryReqDto,
  TCreateCompanySpecificIndustryResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/create-company-specific-industry.dto";
import { TGetCompanySpecificIndustryListResDto } from "@/api/services/global/master/dtos/companySpecificIndustry/get-master-company-specific-industry-list.dto";
import {
  TUpdateCompanySpecificBusinessClassificationReqDto,
  TUpdateCompanySpecificBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/update-company-business-classification.dto";
import {
  TUpdateCompanySpecificIndustryReqDto,
  TUpdateCompanySpecificIndustryResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/update-company-specific-industry.dto";

import { TCreateMainIndustryReqDto, TCreateMainIndustryResDto } from "@/api/services/global/master/dtos/create-main-industry.dto";

import { TCreateSkillTestReqDto, TCreateSkillTestResDto } from "@/api/services/global/master/dtos/create-skill-test.dto";
import {
  TCreateAttachmentDocumentTypeReqDto,
  TCreateAttachmentDocumentTypeResDto,
} from "@/api/services/global/master/dtos/attachment-document-type/create-attachment-document-type.dto";
import { TCreateSupportLanguageReqDto, TCreateSupportLanguageResDto } from "@/api/services/global/master/dtos/create-support-language.dto";
import { TGetMasterListResDto } from "@/api/services/global/master/dtos/get-master-list.dto";
import { TGetMainIndustryListResDto } from "@/api/services/global/master/dtos/get-master-main-industry-list.dto";
import { TGetSkillTestListResDto } from "@/api/services/global/master/dtos/get-master-skill-test-list.dto";
import { TGetAttachmentDocumentTypeListResDto } from "@/api/services/global/master/dtos/attachment-document-type/get-master-attachment-document-type-list.dto";
import { TGetSupportLanguageListResDto } from "@/api/services/global/master/dtos/get-master-support-language-list.dto";
import { TGetSpecificSkillCertificateListResDto } from "@/api/services/global/master/dtos/specificSkillCertificate/get-master-specific-skill-certificate-list.dto";
import {
  TCreateSpecificSkillCertificateReqDto,
  TCreateSpecificSkillCertificateResDto,
} from "@/api/services/global/master/dtos/specificSkillCertificate/create-specific-skill-certificate.dto";
import {
  TUpdateSpecificSkillCertificateReqDto,
  TUpdateSpecificSkillCertificateResDto,
} from "@/api/services/global/master/dtos/specificSkillCertificate/update-specific-skill-certificate.dto";
import {
  TSetHiddenSpecificSkillCertificateReqDto,
  TSetHiddenSpecificSkillCertificateResDto,
} from "@/api/services/global/master/dtos/specificSkillCertificate/set-hidden-specific-skill-certificate.dto";
import {
  TCreateCertificateIndustryRelationReqDto,
  TCreateCertificateIndustryRelationResDto,
} from "@/api/services/global/master/dtos/specificSkillCertificate/create-certificate-industry-relation.dto";
import {
  TUpdateCertificateIndustryRelationReqDto,
  TUpdateCertificateIndustryRelationResDto,
} from "@/api/services/global/master/dtos/specificSkillCertificate/update-certificate-industry-relation.dto";
import { TCreateJobTypeReqDto, TCreateJobTypeResDto } from "@/api/services/global/master/dtos/jobType/create-job-type.dto";
import { TCreateMajorReqDto, TCreateMajorResDto } from "@/api/services/global/master/dtos/jobType/create-major.dto";
import { TGetMajorListResDto } from "@/api/services/global/master/dtos/jobType/get-master-major-list.dto";
import { TUpdateJobTypeReqDto, TUpdateJobTypeResDto } from "@/api/services/global/master/dtos/jobType/update-job-type.dto";
import { TUpdateMajorReqDto, TUpdateMajorResDto } from "@/api/services/global/master/dtos/jobType/update-major.dto";
import { TCreateLanguageTestReqDto, TCreateLanguageTestResDto } from "@/api/services/global/master/dtos/languageTest/create-language-test.dto";
import {
  TCreateLanguageTestLevelReqDto,
  TCreateLanguageTestLevelResDto,
} from "@/api/services/global/master/dtos/languageTest/create-language-test-level.dto";
import { TGetLanguageTestListResDto } from "@/api/services/global/master/dtos/languageTest/get-master-language-test-list.dto";
import {
  TSortLanguageTestReqDto,
  TSortLanguageTestResDto,
  TUpdateLanguageTestReqDto,
  TUpdateLanguageTestResDto,
} from "@/api/services/global/master/dtos/languageTest/update-language-test.dto";
import {
  TUpdateLanguageTestLevelReqDto,
  TUpdateLanguageTestLevelResDto,
} from "@/api/services/global/master/dtos/languageTest/update-language-test-level.dto";
import {
  TSetHiddenLanguageTestReqDto,
  TSetHiddenLanguageTestResDto,
} from "@/api/services/global/master/dtos/languageTest/set-hidden-language-test.dto";
import {
  TSetHiddenAttachmentDocumentTypeReqDto,
  TSetHiddenAttachmentDocumentTypeResDto,
} from "@/api/services/global/master/dtos/attachment-document-type/set-hidden-attachment-document-type.dto";
import {
  TSetHiddenLanguageTestLevelReqDto,
  TSetHiddenLanguageTestLevelResDto,
} from "@/api/services/global/master/dtos/languageTest/set-hidden-language-test-level.dto";
import { TCreateNationalityReqDto, TCreateNationalityResDto } from "@/api/services/global/master/dtos/nationality/create-nationality.dto";
import { TCreateRegionReqDto, TCreateRegionResDto } from "@/api/services/global/master/dtos/nationality/create-region.dto";
import { TGetNationalityListResDto } from "@/api/services/global/master/dtos/nationality/get-master-nationality-list.dto";
import { TGetRegionListResDto } from "@/api/services/global/master/dtos/nationality/get-master-region-list.dto";
import { TUpdateNationalityReqDto, TUpdateNationalityResDto } from "@/api/services/global/master/dtos/nationality/update-nationality.dto";
import {
  TUpdateOrderNationalityListReqDto,
  TUpdateOrderNationalityListResDto,
} from "@/api/services/global/master/dtos/nationality/update-order-nationality-list.dto";
import { TUpdateRegionReqDto, TUpdateRegionResDto } from "@/api/services/global/master/dtos/nationality/update-region.dto";
import {
  TCreateResidencePeriodReqDto,
  TCreateResidencePeriodResDto,
} from "@/api/services/global/master/dtos/residencePeriod/create-residence-period.dto";
import {
  TCreateResidenceStatusReqDto,
  TCreateResidenceStatusResDto,
} from "@/api/services/global/master/dtos/residencePeriod/create-residence-status.dto";
import { TGetResidenceStatusListResDto } from "@/api/services/global/master/dtos/residencePeriod/get-master-residence-status-list.dto";
import {
  TUpdateResidencePeriodReqDto,
  TUpdateResidencePeriodResDto,
} from "@/api/services/global/master/dtos/residencePeriod/update-residence-period.dto";
import {
  TUpdateResidenceStatusReqDto,
  TUpdateResidenceStatusResDto,
} from "@/api/services/global/master/dtos/residencePeriod/update-residence-status.dto";
import { TUpdateMainIndustryReqDto, TUpdateMainIndustryResDto } from "@/api/services/global/master/dtos/update-main-industry.dto";
import { TUpdateSkillTestReqDto, TUpdateSkillTestResDto } from "@/api/services/global/master/dtos/update-skill-test.dto";
import {
  TUpdateAttachmentDocumentTypeReqDto,
  TUpdateAttachmentDocumentTypeResDto,
} from "@/api/services/global/master/dtos/attachment-document-type/update-attachment-document-type.dto";
import { TUpdateSupportLanguageReqDto, TUpdateSupportLanguageResDto } from "@/api/services/global/master/dtos/update-support-language.dto";
import {
  TCreateBusinessClassificationReqDto,
  TCreateBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/businessClassification/create-business-classification.dto";
import {
  TUpdateBusinessClassificationReqDto,
  TUpdateBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/businessClassification/update-business-classification.dto";
import { TGetBusinessClassificationListResDto } from "@/api/services/global/master/dtos/businessClassification/get-business-classification-list.dto";
import {
  TSetHiddenBusinessClassificationReqDto,
  TSetHiddenBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/businessClassification/set-hidden-business-classification.dto";
import { TGetDefaultProductListResDto } from "@/api/services/global/master/dtos/defaultProduct/get-master-default-product-list.dto";
import {
  TCreateDefaultProductReqDto,
  TCreateDefaultProductResDto,
} from "@/api/services/global/master/dtos/defaultProduct/create-default-product.dto";
import {
  TUpdateDefaultProductReqDto,
  TUpdateDefaultProductResDto,
} from "@/api/services/global/master/dtos/defaultProduct/update-default-product.dto";
import {
  TUpdateOrderDefaultProductReqDto,
  TUpdateOrderDefaultProductResDto,
} from "@/api/services/global/master/dtos/defaultProduct/update-order-default-product.dto";
import {
  TSetHiddenDefaultProductReqDto,
  TSetHiddenDefaultProductResDto,
} from "@/api/services/global/master/dtos/defaultProduct/set-hidden-default-product.dto";
import { TGetTaxRateListResDto } from "@/api/services/global/master/dtos/taxRate/get-master-tax-rate-list.dto";
import { TCreateTaxRateReqDto, TCreateTaxRateResDto } from "@/api/services/global/master/dtos/taxRate/create-tax-rate.dto";
import { TUpdateTaxRateReqDto, TUpdateTaxRateResDto } from "@/api/services/global/master/dtos/taxRate/update-tax-rate.dto";
import { TUpdateOrderTaxRateReqDto, TUpdateOrderTaxRateResDto } from "@/api/services/global/master/dtos/taxRate/update-order-tax-rate.dto";
import { TSetHiddenTaxRateReqDto, TSetHiddenTaxRateResDto } from "@/api/services/global/master/dtos/taxRate/set-hidden-tax-rate.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { globalApi } from "@/utils/api";
import { toNumber } from "@/utils/number";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import {
  TSetHiddenCertificateIndustryRelationReqDto,
  TSetHiddenCertificateIndustryRelationResDto,
} from "@/api/services/global/master/dtos/specificSkillCertificate/set-hidden-certificate-industry-relation.dto";

//get-master-list
export const fetchMasterListApi = async (): Promise<TGetMasterListResDto> => {
  const rs = await globalApi.get<TGetMasterListResDto>(`/master`);
  return rs.data;
};

export const useGetMasterDataList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_DATA],
    queryFn: () => fetchMasterListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//nationalities
export const fetchNationalityListApi = async (): Promise<TGetNationalityListResDto> => {
  const rs = await globalApi.get<TGetNationalityListResDto>(`/master/regions/nationalities`);
  return rs.data;
};

export const fetchRegionListApi = async (): Promise<TGetRegionListResDto> => {
  const rs = await globalApi.get<TGetRegionListResDto>(`/master/regions`);
  return rs.data;
};

export const createRegionApi = async (payload: TCreateRegionReqDto): Promise<TCreateRegionResDto> => {
  const rs = await globalApi.post<TCreateRegionResDto>("/master/regions", payload);
  return rs.data;
};

export const createNationalityApi = async (payload: TCreateNationalityReqDto): Promise<TCreateNationalityResDto> => {
  const rs = await globalApi.post<TCreateNationalityResDto>(`/master/regions/${payload.regionId}/nationalities`, payload);
  return rs.data;
};

export const updateNationalityApi = async (nationalityId: number, payload: TUpdateNationalityReqDto): Promise<TUpdateNationalityResDto> => {
  const rs = await globalApi.put<TUpdateNationalityResDto>(`/master/regions/${payload.regionId}/nationalities/${nationalityId}`, payload);
  return rs.data;
};

export const updateOrderNationalityListApi = async (payload: TUpdateOrderNationalityListReqDto): Promise<TUpdateOrderNationalityListResDto> => {
  const rs = await globalApi.put<TUpdateOrderNationalityListResDto>(`/master/regions/nationalities/order`, payload);
  return rs.data;
};

export const setHiddenNationalityApi = async (
  regionId: number,
  nationalityId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateNationalityResDto> => {
  const rs = await globalApi.put<TUpdateNationalityResDto>(`/master/regions/${regionId}/nationalities/${nationalityId}/set-hidden`, payload);
  return rs.data;
};

export const updateRegionApi = async (payload: TUpdateRegionReqDto): Promise<TUpdateRegionResDto> => {
  const rs = await globalApi.put<TUpdateRegionResDto>("/master/regions", payload);
  return rs.data;
};

export const setHiddenRegionApi = async (regionId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/regions/${regionId}/set-hidden`, payload);
  return rs.data;
};

export const useGetNationalityList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_NATIONALITY],
    queryFn: () => fetchNationalityListApi(),
  });

  const nationalityOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.nationalityName, value: item.id, hidden: item.isHidden })) : []),
    [data],
  );

  return { data: data?.data ?? [], nationalityOptions, ...rest };
};

export const useGetRegionList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_REGION],
    queryFn: () => fetchRegionListApi(),
  });

  const nationalityOptions = useMemo(
    () =>
      data
        ? data.data.flatMap((item) => item.nationalities).map((item) => ({ label: item.nationalityName, value: item.id, hidden: item.isHidden }))
        : [],
    [data],
  );

  const regionOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.regionName, value: item.id, hidden: item.isHidden })) : []),
    [data],
  );

  return { data: data?.data ?? [], nationalityOptions, regionOptions, ...rest };
};

//job-types
export const fetchMajorListApi = async (): Promise<TGetMajorListResDto> => {
  const rs = await globalApi.get<TGetMajorListResDto>(`/master/majors`);
  return rs.data;
};

export const createMajorApi = async (payload: TCreateMajorReqDto): Promise<TCreateMajorResDto> => {
  const rs = await globalApi.post<TCreateMajorResDto>("/master/majors", payload);
  return rs.data;
};

export const createJobTypeApi = async (payload: TCreateJobTypeReqDto): Promise<TCreateJobTypeResDto> => {
  const rs = await globalApi.post<TCreateJobTypeResDto>(`/master/majors/${payload.majorId}/job-types`, payload);
  return rs.data;
};

export const updateJobTypeApi = async (jobTypeId: number, payload: TUpdateJobTypeReqDto): Promise<TUpdateJobTypeResDto> => {
  const rs = await globalApi.put<TUpdateJobTypeResDto>(`/master/majors/${payload.majorId}/job-types/${jobTypeId}`, payload);
  return rs.data;
};
export const setHiddenJobTypeApi = async (majorId: number, jobTypeId: number, payload: { isHidden: boolean }): Promise<TUpdateJobTypeResDto> => {
  const rs = await globalApi.put<TUpdateJobTypeResDto>(`/master/majors/${majorId}/job-types/${jobTypeId}/set-hidden`, payload);
  return rs.data;
};

export const updateMajorApi = async (payload: TUpdateMajorReqDto): Promise<TUpdateMajorResDto> => {
  const rs = await globalApi.put<TUpdateMajorResDto>("/master/majors", payload);
  return rs.data;
};

export const setHiddenMajorApi = async (majorId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/majors/${majorId}/set-hidden`, payload);
  return rs.data;
};

export const useGetMajorList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_MAJOR],
    queryFn: () => fetchMajorListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//residence-periods
export const fetchResidenceStatusListApi = async (): Promise<TGetResidenceStatusListResDto> => {
  const rs = await globalApi.get<TGetResidenceStatusListResDto>(`/master/residence-statuses`);
  return rs.data;
};

export const createResidenceStatusApi = async (payload: TCreateResidenceStatusReqDto): Promise<TCreateResidenceStatusResDto> => {
  const rs = await globalApi.post<TCreateResidenceStatusResDto>("/master/residence-statuses", payload);
  return rs.data;
};

export const createResidencePeriodApi = async (payload: TCreateResidencePeriodReqDto): Promise<TCreateResidencePeriodResDto> => {
  const rs = await globalApi.post<TCreateResidencePeriodResDto>(`/master/residence-statuses/${payload.residenceStatusId}/residence-periods`, payload);
  return rs.data;
};

export const updateResidencePeriodApi = async (
  residencePeriodId: number,
  payload: TUpdateResidencePeriodReqDto,
): Promise<TUpdateResidencePeriodResDto> => {
  const rs = await globalApi.put<TUpdateResidencePeriodResDto>(
    `/master/residence-statuses/${payload.residenceStatusId}/residence-periods/${residencePeriodId}`,
    payload,
  );
  return rs.data;
};

export const setHiddenResidencePeriodApi = async (
  residenceStatusId: number,
  residencePeriodId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateResidencePeriodResDto> => {
  const rs = await globalApi.put<TUpdateResidencePeriodResDto>(
    `/master/residence-statuses/${residenceStatusId}/residence-periods/${residencePeriodId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const updateResidenceStatusApi = async (payload: TUpdateResidenceStatusReqDto): Promise<TUpdateResidenceStatusResDto> => {
  const rs = await globalApi.put<TUpdateResidenceStatusResDto>("/master/residence-statuses", payload);
  return rs.data;
};

export const setHiddenResidenceStatusApi = async (residenceStatusId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/residence-statuses/${residenceStatusId}/set-hidden`, payload);
  return rs.data;
};

export const useGetResidenceStatusList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_RESIDENCE_STATUS],
    queryFn: () => fetchResidenceStatusListApi(),
  });

  const residenceStatusOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.residenceStatus, value: item.id, hidden: item.isHidden })) : []),
    [data],
  );

  return { data: data?.data ?? [], residenceStatusOptions, ...rest };
};

//language-test
export const fetchLanguageTestListApi = async (): Promise<TGetLanguageTestListResDto> => {
  const rs = await globalApi.get<TGetLanguageTestListResDto>("/master/language-tests");
  return rs.data;
};

export const createLanguageTestApi = async (payload: TCreateLanguageTestReqDto): Promise<TCreateLanguageTestResDto> => {
  const rs = await globalApi.post<TCreateLanguageTestResDto>("/master/language-tests", payload);
  return rs.data;
};

export const updateLanguageTestApi = async (payload: TUpdateLanguageTestReqDto): Promise<TUpdateLanguageTestResDto> => {
  const rs = await globalApi.put<TUpdateLanguageTestResDto>("/master/language-tests", payload);
  return rs.data;
};

export const sortLanguageTestApi = async (payload: TSortLanguageTestReqDto): Promise<TSortLanguageTestResDto> => {
  const rs = await globalApi.put<TSortLanguageTestResDto>("/master/language-tests/sort", payload);
  return rs.data;
};

export const createLanguageTestLevelApi = async (
  languageTestId: number,
  payload: TCreateLanguageTestLevelReqDto,
): Promise<TCreateLanguageTestLevelResDto> => {
  const rs = await globalApi.post<TCreateLanguageTestLevelResDto>(`/master/language-tests/${languageTestId}/levels`, payload);
  return rs.data;
};

export const updateLanguageTestLevelApi = async (
  languageTestId: number,
  levelId: number,
  payload: TUpdateLanguageTestLevelReqDto,
): Promise<TUpdateLanguageTestLevelResDto> => {
  const rs = await globalApi.put<TUpdateLanguageTestLevelResDto>(`/master/language-tests/${languageTestId}/levels/${levelId}`, payload);
  return rs.data;
};

export const setHiddenLanguageTestApi = async (
  languageTestId: number,
  payload: TSetHiddenLanguageTestReqDto,
): Promise<TSetHiddenLanguageTestResDto> => {
  const rs = await globalApi.put<TSetHiddenLanguageTestResDto>(`/master/language-tests/${languageTestId}/set-hidden`, payload);
  return rs.data;
};

export const setHiddenLanguageTestLevelApi = async (
  languageTestId: number,
  levelId: number,
  payload: TSetHiddenLanguageTestLevelReqDto,
): Promise<TSetHiddenLanguageTestLevelResDto> => {
  const rs = await globalApi.put<TSetHiddenLanguageTestLevelResDto>(`/master/language-tests/${languageTestId}/levels/${levelId}/set-hidden`, payload);
  return rs.data;
};

export const useGetLanguageTestList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_LANGUAGE_TEST],
    queryFn: () => fetchLanguageTestListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//main-industry
export const fetchMainIndustryListApi = async (): Promise<TGetMainIndustryListResDto> => {
  const rs = await globalApi.get<TGetMainIndustryListResDto>("/master/main-industries");
  return rs.data;
};

export const createMainIndustryApi = async (payload: TCreateMainIndustryReqDto): Promise<TCreateMainIndustryResDto> => {
  const rs = await globalApi.post<TCreateMainIndustryResDto>("/master/main-industries", payload);
  return rs.data;
};

export const updateMainIndustryApi = async (payload: TUpdateMainIndustryReqDto): Promise<TUpdateMainIndustryResDto> => {
  const rs = await globalApi.put<TUpdateMainIndustryResDto>("/master/main-industries", payload);
  return rs.data;
};

export const setHiddenMainIndustryApi = async (mainIndustryId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/main-industries/${mainIndustryId}/set-hidden`, payload);
  return rs.data;
};

export const useGetMainIndustryList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_MAIN_INDUSTRY],
    queryFn: () => fetchMainIndustryListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//skill-test
export const fetchSkillTestListApi = async (): Promise<TGetSkillTestListResDto> => {
  const rs = await globalApi.get<TGetSkillTestListResDto>("/master/skill-tests");
  return rs.data;
};

export const createSkillTestApi = async (payload: TCreateSkillTestReqDto): Promise<TCreateSkillTestResDto> => {
  const rs = await globalApi.post<TCreateSkillTestResDto>("/master/skill-tests", payload);
  return rs.data;
};

export const updateSkillTestApi = async (payload: TUpdateSkillTestReqDto): Promise<TUpdateSkillTestResDto> => {
  const rs = await globalApi.put<TUpdateSkillTestResDto>("/master/skill-tests", payload);
  return rs.data;
};

export const setHiddenSkillTestApi = async (skillTestId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/skill-tests/${skillTestId}/set-hidden`, payload);
  return rs.data;
};

export const useGetSkillTestList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_SKILL_TEST],
    queryFn: () => fetchSkillTestListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//company-specific-industry
export const fetchCompanySpecificIndustryListApi = async (): Promise<TGetCompanySpecificIndustryListResDto> => {
  const rs = await globalApi.get<TGetCompanySpecificIndustryListResDto>(`/master/company-specific-industries`);
  return rs.data;
};

export const createCompanySpecificIndustryApi = async (
  payload: TCreateCompanySpecificIndustryReqDto,
): Promise<TCreateCompanySpecificIndustryResDto> => {
  const rs = await globalApi.post<TCreateCompanySpecificIndustryResDto>("/master/company-specific-industries", payload);
  return rs.data;
};

export const createCompanySpecificBusinessClassificationApi = async (
  payload: TCreateCompanySpecificBusinessClassificationReqDto,
): Promise<TCreateCompanySpecificBusinessClassificationResDto> => {
  const rs = await globalApi.post<TCreateCompanySpecificBusinessClassificationResDto>(
    `/master/company-specific-industries/${payload.companySpecificIndustryId}/company-specific-business-classifications`,
    payload,
  );
  return rs.data;
};

export const updateCompanySpecificBusinessClassificationApi = async (
  companySpecificBusinessClassificationId: number,
  payload: TUpdateCompanySpecificBusinessClassificationReqDto,
): Promise<TUpdateCompanySpecificBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateCompanySpecificBusinessClassificationResDto>(
    `/master/company-specific-industries/${payload.companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}`,
    payload,
  );
  return rs.data;
};
export const setHiddenCompanySpecificBusinessClassificationApi = async (
  companySpecificIndustryId: number,
  companySpecificBusinessClassificationId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateCompanySpecificBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateCompanySpecificBusinessClassificationResDto>(
    `/master/company-specific-industries/${companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const updateCompanySpecificIndustryApi = async (
  payload: TUpdateCompanySpecificIndustryReqDto,
): Promise<TUpdateCompanySpecificIndustryResDto> => {
  const rs = await globalApi.put<TUpdateCompanySpecificIndustryResDto>("/master/company-specific-industries", payload);
  return rs.data;
};

export const setHiddenCompanySpecificIndustryApi = async (companySpecificIndustryId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/company-specific-industries/${companySpecificIndustryId}/set-hidden`, payload);
  return rs.data;
};

export const useGetCompanySpecificIndustryList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_COMPANY_SPECIFIC_INDUSTRY],
    queryFn: () => fetchCompanySpecificIndustryListApi(),
  });

  const companySpecificIndustryOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.companySpecificIndustry, value: toNumber(item.id), hidden: item.isHidden })) : []),
    [data],
  );

  const getCompanySpecificBusinessClassificationListOptionByCompanySpecificIndustry = useCallback(
    (companySpecificIndustryId: number | string) => {
      const foundCompanySpecificIndustry = data ? data.data.find((item) => toNumber(item.id) === toNumber(companySpecificIndustryId)) : undefined;
      if (!foundCompanySpecificIndustry) return [];
      const options =
        foundCompanySpecificIndustry?.companySpecificBusinessClassifications?.map((item) => ({
          label: item.companySpecificBusinessClassificationName,
          value: String(item.id),
          hidden: item.isHidden,
        })) || [];
      return options;
    },
    [data],
  );

  return {
    data: data?.data ?? [],
    companySpecificIndustryOptions,
    getCompanySpecificBusinessClassificationListOptionByCompanySpecificIndustry,
    ...rest,
  };
};

//support-language
export const fetchSupportLanguageListApi = async (): Promise<TGetSupportLanguageListResDto> => {
  const rs = await globalApi.get<TGetSupportLanguageListResDto>("/master/support-languages");
  return rs.data;
};

export const createSupportLanguageApi = async (payload: TCreateSupportLanguageReqDto): Promise<TCreateSupportLanguageResDto> => {
  const rs = await globalApi.post<TCreateSupportLanguageResDto>("/master/support-languages", payload);
  return rs.data;
};

export const updateSupportLanguageApi = async (payload: TUpdateSupportLanguageReqDto): Promise<TUpdateSupportLanguageResDto> => {
  const rs = await globalApi.put<TUpdateSupportLanguageResDto>("/master/support-languages", payload);
  return rs.data;
};

export const setHiddenSupportLanguageApi = async (supportLanguageId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/support-languages/${supportLanguageId}/set-hidden`, payload);
  return rs.data;
};

export const useGetSupportLanguageList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_SUPPORT_LANGUAGE],
    queryFn: () => fetchSupportLanguageListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

// Business Classification
export const getBusinessClassificationListApi = async (): Promise<TGetBusinessClassificationListResDto> => {
  const rs = await globalApi.get<TGetBusinessClassificationListResDto>(`/master/business-classifications`);
  return rs.data;
};

export const createBusinessClassificationApi = async (payload: TCreateBusinessClassificationReqDto): Promise<TCreateBusinessClassificationResDto> => {
  const rs = await globalApi.post<TCreateBusinessClassificationResDto>(`/master/business-classifications`, payload);
  return rs.data;
};

export const updateBusinessClassificationApi = async (payload: TUpdateBusinessClassificationReqDto): Promise<TUpdateBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateBusinessClassificationResDto>(`/master/business-classifications`, payload);
  return rs.data;
};

export const setHiddenBusinessClassificationApi = async (
  id: number,
  payload: TSetHiddenBusinessClassificationReqDto,
): Promise<TSetHiddenBusinessClassificationResDto> => {
  const rs = await globalApi.put<TSetHiddenBusinessClassificationResDto>(`/master/business-classifications/${id}/set-hidden`, payload);
  return rs.data;
};

export const useGetBusinessClassificationList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_BUSINESS_CLASSIFICATION],
    queryFn: () => getBusinessClassificationListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

// Attachment Document Type
export const fetchAttachmentDocumentTypeListApi = async (): Promise<TGetAttachmentDocumentTypeListResDto> => {
  const rs = await globalApi.get<TGetAttachmentDocumentTypeListResDto>("/master/attachment-document-types");
  return rs.data;
};

export const createAttachmentDocumentTypeApi = async (payload: TCreateAttachmentDocumentTypeReqDto): Promise<TCreateAttachmentDocumentTypeResDto> => {
  const rs = await globalApi.post<TCreateAttachmentDocumentTypeResDto>("/master/attachment-document-types", payload);
  return rs.data;
};

export const updateAttachmentDocumentTypeApi = async (payload: TUpdateAttachmentDocumentTypeReqDto): Promise<TUpdateAttachmentDocumentTypeResDto> => {
  const rs = await globalApi.put<TUpdateAttachmentDocumentTypeResDto>("/master/attachment-document-types", payload);
  return rs.data;
};

export const setHiddenAttachmentDocumentTypeApi = async (
  attachmentDocumentTypeId: number,
  payload: TSetHiddenAttachmentDocumentTypeReqDto,
): Promise<TSetHiddenAttachmentDocumentTypeResDto> => {
  const rs = await globalApi.put<TSetHiddenAttachmentDocumentTypeResDto>(
    `/master/attachment-document-types/${attachmentDocumentTypeId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const useGetAttachmentDocumentTypeList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_ATTACHMENT_DOCUMENT_TYPE],
    queryFn: () => fetchAttachmentDocumentTypeListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

// Tax Rate
export const fetchTaxRateListApi = async (): Promise<TGetTaxRateListResDto> => {
  const rs = await globalApi.get<TGetTaxRateListResDto>("/master/tax-rates");
  return rs.data;
};

export const createTaxRateApi = async (payload: TCreateTaxRateReqDto): Promise<TCreateTaxRateResDto> => {
  const rs = await globalApi.post<TCreateTaxRateResDto>("/master/tax-rates", payload);
  return rs.data;
};

/** 1件更新 */
export const updateTaxRateApi = async (taxRateId: number, payload: TUpdateTaxRateReqDto): Promise<TUpdateTaxRateResDto> => {
  const rs = await globalApi.put<TUpdateTaxRateResDto>(`/master/tax-rates/${taxRateId}`, payload);
  return rs.data;
};

/** 並び替え専用。配列の並び順が新しい表示順序になる */
export const updateOrderTaxRateApi = async (payload: TUpdateOrderTaxRateReqDto): Promise<TUpdateOrderTaxRateResDto> => {
  const rs = await globalApi.put<TUpdateOrderTaxRateResDto>("/master/tax-rates/order", payload);
  return rs.data;
};

export const setHiddenTaxRateApi = async (taxRateId: number, payload: TSetHiddenTaxRateReqDto): Promise<TSetHiddenTaxRateResDto> => {
  const rs = await globalApi.put<TSetHiddenTaxRateResDto>(`/master/tax-rates/${taxRateId}/set-hidden`, payload);
  return rs.data;
};

export const useGetTaxRateList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_TAX_RATE],
    queryFn: () => fetchTaxRateListApi(),
  });

  // 無効化した税率は選択肢に出さない（すでに選択済みの値のみ表示される）
  const taxRateOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.displayName, value: toNumber(item.id), hidden: item.isHidden })) : []),
    [data],
  );

  return { data: data?.data ?? [], taxRateOptions, ...rest };
};

// Default Product
export const fetchDefaultProductListApi = async (): Promise<TGetDefaultProductListResDto> => {
  const rs = await globalApi.get<TGetDefaultProductListResDto>("/master/default-products");
  return rs.data;
};

export const createDefaultProductApi = async (payload: TCreateDefaultProductReqDto): Promise<TCreateDefaultProductResDto> => {
  const rs = await globalApi.post<TCreateDefaultProductResDto>("/master/default-products", payload);
  return rs.data;
};

/** 1件更新 */
export const updateDefaultProductApi = async (
  defaultProductId: number,
  payload: TUpdateDefaultProductReqDto,
): Promise<TUpdateDefaultProductResDto> => {
  const rs = await globalApi.put<TUpdateDefaultProductResDto>(`/master/default-products/${defaultProductId}`, payload);
  return rs.data;
};

/** 並び替え専用。配列の並び順が新しい表示順序になる */
export const updateOrderDefaultProductApi = async (payload: TUpdateOrderDefaultProductReqDto): Promise<TUpdateOrderDefaultProductResDto> => {
  const rs = await globalApi.put<TUpdateOrderDefaultProductResDto>("/master/default-products/order", payload);
  return rs.data;
};

export const setHiddenDefaultProductApi = async (
  defaultProductId: number,
  payload: TSetHiddenDefaultProductReqDto,
): Promise<TSetHiddenDefaultProductResDto> => {
  const rs = await globalApi.put<TSetHiddenDefaultProductResDto>(`/master/default-products/${defaultProductId}/set-hidden`, payload);
  return rs.data;
};

export const useGetDefaultProductList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_DEFAULT_PRODUCT],
    queryFn: () => fetchDefaultProductListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

// Specific Skill Certificate
export const fetchSpecificSkillCertificateListApi = async (): Promise<TGetSpecificSkillCertificateListResDto> => {
  const rs = await globalApi.get<TGetSpecificSkillCertificateListResDto>("/master/specific-skill-certificates");
  return rs.data;
};

export const createSpecificSkillCertificateApi = async (
  payload: TCreateSpecificSkillCertificateReqDto,
): Promise<TCreateSpecificSkillCertificateResDto> => {
  const rs = await globalApi.post<TCreateSpecificSkillCertificateResDto>("/master/specific-skill-certificates", payload);
  return rs.data;
};

export const updateSpecificSkillCertificateApi = async (
  payload: TUpdateSpecificSkillCertificateReqDto,
): Promise<TUpdateSpecificSkillCertificateResDto> => {
  const rs = await globalApi.put<TUpdateSpecificSkillCertificateResDto>("/master/specific-skill-certificates", payload);
  return rs.data;
};

export const setHiddenSpecificSkillCertificateApi = async (
  specificSkillCertificateId: number,
  payload: TSetHiddenSpecificSkillCertificateReqDto,
): Promise<TSetHiddenSpecificSkillCertificateResDto> => {
  const rs = await globalApi.put<TSetHiddenSpecificSkillCertificateResDto>(
    `/master/specific-skill-certificates/${specificSkillCertificateId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const setHiddenCertificateIndustryRelationApi = async (
  specificSkillCertificateId: number,
  companySpecificIndustryId: number,
  payload: TSetHiddenCertificateIndustryRelationReqDto,
): Promise<TSetHiddenCertificateIndustryRelationResDto> => {
  const rs = await globalApi.put<TSetHiddenCertificateIndustryRelationResDto>(
    `/master/specific-skill-certificates/${specificSkillCertificateId}/company-specific-industries/${companySpecificIndustryId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const createCertificateIndustryRelationApi = async (
  specificSkillCertificateId: number,
  payload: TCreateCertificateIndustryRelationReqDto,
): Promise<TCreateCertificateIndustryRelationResDto> => {
  const rs = await globalApi.post<TCreateCertificateIndustryRelationResDto>(
    `/master/specific-skill-certificates/${specificSkillCertificateId}/company-specific-industries`,
    payload,
  );
  return rs.data;
};

export const updateCertificateIndustryRelationApi = async (
  specificSkillCertificateId: number,
  companySpecificIndustryId: number,
  payload: TUpdateCertificateIndustryRelationReqDto,
): Promise<TUpdateCertificateIndustryRelationResDto> => {
  const rs = await globalApi.put<TUpdateCertificateIndustryRelationResDto>(
    `/master/specific-skill-certificates/${specificSkillCertificateId}/company-specific-industries/${companySpecificIndustryId}`,
    payload,
  );
  return rs.data;
};

export const useGetSpecificSkillCertificateList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_SPECIFIC_SKILL_CERTIFICATE],
    queryFn: () => fetchSpecificSkillCertificateListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};
